import { render } from "./BusReportList.vue?vue&type=template&id=6e428398&scoped=true"
import script from "./BusReportList.vue?vue&type=script&lang=js"
export * from "./BusReportList.vue?vue&type=script&lang=js"

import "./BusReportList.vue?vue&type=style&index=0&id=6e428398&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e428398"]])

export default __exports__